import './LiteApiModal.scss';
export class LiteApiModalController {
    static $inject = ['data', 'close', '$translate'];
    constructor(data, close, $translate) {
        'ngInject';
        this.close = close;
        this.$translate = $translate;
        this.closeModal = () => {
            this.close();
        };
        this.isEmpty = (data) => {
            return !data || data.length === 0;
        };
        this.isNumericString = (value) => {
            return !isNaN(parseFloat(value)) && isFinite(Number(value));
        };
        this.populateData = async () => {
            if (this.isEmpty(this.data)) {
                return;
            }
            const entries = Object.entries(this.data);
            this.preparedData = [];
            for (const [key, value] of entries) {
                try {
                    const translatedName = await this.$translate(`liteApiModal.details.${key}`);
                    if (!translatedName) {
                        return;
                    }
                    const roundedValue = typeof value === 'string' && this.isNumericString(value) ? parseFloat(value) : value;
                    this.preparedData.push({
                        name: translatedName,
                        value: roundedValue,
                    });
                }
                catch (error) {
                    console.error(`Error translating key ${key}:`, error);
                }
            }
        };
        const defaultData = {
            marketing_messages_sent: 0,
            marketing_messages_read: 0,
            marketing_messages_delivered: 0,
            marketing_messages_link_btn_click: 0,
            marketing_messages_delivery_rate: 0,
            marketing_messages_read_rate: 0,
            marketing_messages_link_btn_click_rate: 0,
            marketing_messages_spend: 0,
            marketing_messages_cost_per_delivered: 0,
            marketing_messages_cost_per_link_btn_click: 0,
            marketing_messages_website_add_to_cart: '0',
            marketing_messages_website_initiate_checkout: '0',
            marketing_messages_website_purchase: '0',
            marketing_messages_website_purchase_values: '0',
            campaign_id: '',
            adset_id: '',
            ad_id: '',
            account_id: '',
            date_start: '',
            date_stop: '',
        };
        this.data = { ...defaultData, ...data };
        this.init();
    }
    init() {
        this.populateData();
    }
}
LiteApiModalController.$inject = ['data', 'close', '$translate'];
